import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from "react-oidc-context";



const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const cognitoAuthConfig = {
    authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_0Dbbqm5kG", //process.env.NEXT_PUBLIC_COGNITO_AUTHORITY,
    client_id: "440c37q24pb5b13grbsaffndit", //process.env.NEXT_PUBLIC_COGNITO_CLIENT_ID,
    redirect_uri: "https://games.quirosreyes.com", //process.env.NEXT_PUBLIC_COGNITO_REDIRECT_URI,
    //redirect_uri: "http://localhost:3000", //process.env.NEXT_PUBLIC_COGNITO_REDIRECT_URI,
    response_type: "code",
    scope: "email openid phone",
};

document.body.classList.add("bg-gray-800", "text-gray-200");

root.render(
  <React.StrictMode>
      <AuthProvider {...cognitoAuthConfig}>
          <App />
      </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
